let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lrEVZ")).then(() => parcelRequire('af8GT'));